import { createReducer, on } from '@ngrx/store';
import { loginSuccess, logout, resetUserState, toggleTechView } from './user.actions';
import { UserState } from './user.model';
import { useLocalStorage } from '../../utilities/browser/localStorage.utilities';

const { getItem, setItem, removeItem } = useLocalStorage();

const getDefaultState = (): UserState => ({
  isLoggedIn: false,
  isTechView: false,
  userInfo: null
});

const loadInitialState = (): UserState => {
  const storedState = getItem('user');
  if (storedState) {
    return JSON.parse(storedState);
  }
  return getDefaultState();
};

export const initialState: UserState = loadInitialState();

export const userReducer = createReducer(
  initialState,
  on(loginSuccess, (state, { userInfo }) => {
    const updatedState = {
      ...state,
      isLoggedIn: true,
      userInfo
    };
    setItem('user', JSON.stringify(updatedState));
    return updatedState;
  }),
  on(logout, () => {
    const clearedState = getDefaultState();
    removeItem('user');
    return clearedState;
  }),
  on(toggleTechView, (state) => {
    const updatedState = { ...state, isTechView: !state.isTechView };
    setItem('user', JSON.stringify(updatedState));
    return updatedState;
  }),
  on(resetUserState, () => initialState)
);
